/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInChatListItemDraftStatus = typeof LinkedInChatListItemDraftStatus[keyof typeof LinkedInChatListItemDraftStatus] | null;


export const LinkedInChatListItemDraftStatus = {
  generating: 'generating',
  ready: 'ready',
  accepted: 'accepted',
  denied: 'denied',
  failed: 'failed',
} as const;
